export const WORKFLOW_CONSTANTS = {
    STAGE_DELETE_CONFIRMATION_TITLE: 'Delete Workflow',
    STAGE_DELETE_CONFIRMATION_CONTENT: 'Are you sure you want to delete this Stage? <br> This action cannot be undone!',
    STAGE_DELETE_SUCCESS: 'Stage deleted successfully',
    ACTION_DELETE_CONFIRMATION_TITLE: 'Delete Stage Action',
    ACTION_DELETE_CONFIRMATION_CONTENT: 'Are you sure you want to delete this Stage action? <br> This action cannot be undone!',
    ACTION_DELETE_SUCCESS: 'Stage action deleted successfully',
    TRY_AGAIN_LATER: 'Something went wrong, please try again later',
    DELETE_ERROR: 'Failed to delete, please try again later',
};